// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SecretChatRequestAccessPopup__head-block-e91b90 {
  display: flex;
  flex-direction: row;
  padding: 0 24px;
  height: 52px;
  align-items: center;
}

.SecretChatRequestAccessPopup__requests-count-a9e8f3 {
  font: var(--font-subtitle-2);
  letter-spacing: var(--font-spacing-subtitle-2);
  color: var(--base-90);
  display: flex;
  flex: 1;
}

.SecretChatRequestAccessPopup__wrapper-d3a7e0 {
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/SecretChatRequestAccessPopup/SecretChatRequestAccessPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;EACA,aAAA;EACA,OAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".head-block {\n  display: flex;\n  flex-direction: row;\n  padding: 0 24px;\n  height: 52px;\n  align-items: center;\n}\n\n.requests-count {\n  font: var(--font-subtitle-2);\n  letter-spacing: var(--font-spacing-subtitle-2);\n  color: var(--base-90);\n  display: flex;\n  flex: 1;\n}\n\n.wrapper {\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head-block": `SecretChatRequestAccessPopup__head-block-e91b90`,
	"headBlock": `SecretChatRequestAccessPopup__head-block-e91b90`,
	"requests-count": `SecretChatRequestAccessPopup__requests-count-a9e8f3`,
	"requestsCount": `SecretChatRequestAccessPopup__requests-count-a9e8f3`,
	"wrapper": `SecretChatRequestAccessPopup__wrapper-d3a7e0`
};
module.exports = ___CSS_LOADER_EXPORT___;
